/* Snoozie quick add on collection cards: single-variant products go straight to the cart,
   others open a small dialog to pick options. Uses the theme's own cart event so the cart drawer and bubble update. */
import { CartLinesUpdateEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

const root = document.querySelector('[data-snc]');
if (root) {
  const fr = root.dataset.locale === 'fr';
  const T = fr
    ? { add: 'Ajouter au panier', adding: 'Ajout…', view: 'Voir tous les détails', sold: 'Épuisé', close: 'Fermer', error: 'Impossible d’ajouter au panier. Réessayez.', from: 'Dès', Color: 'Couleur', Size: 'Taille' }
    : { add: 'Add to cart', adding: 'Adding…', view: 'View full details', sold: 'Sold out', close: 'Close', error: 'Could not add to cart. Please try again.', from: 'From', Color: 'Color', Size: 'Size' };
  let fmt;
  try { fmt = new Intl.NumberFormat((root.dataset.locale || 'en') === 'fr' ? 'fr-CA' : 'en-CA', { style: 'currency', currency: root.dataset.currency || 'CAD' }); } catch (e) { fmt = null; }
  const money = (c) => (fmt ? fmt.format(c / 100) : (c / 100).toFixed(2));
  const base = (root.dataset.root || '/').replace(/\/$/, '');
  const esc = (s) => String(s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));

  async function addToCart(variantId, trigger) {
    const fd = new FormData();
    fd.set('id', String(variantId));
    fd.set('quantity', '1');
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((i) => { if (i instanceof HTMLElement && i.dataset.sectionId) ids.push(i.dataset.sectionId); });
    if (ids.length) fd.append('sections', ids.join(','));
    const deferred = CartLinesUpdateEvent.createPromise();
    trigger.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variantId), quantity: 1 }], promise: deferred.promise }));
    const cfg = fetchConfig('javascript', { body: fd });
    const refresh = () => {
      const comp = document.querySelector('cart-items-component');
      if (comp && comp.fetchCartData) return comp.fetchCartData();
      return fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
    };
    try {
      const res = await fetch(Theme.routes.cart_add_url, { ...cfg, headers: { ...cfg.headers, Accept: 'text/html' } }).then((r) => r.json());
      const cart = await refresh();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'snoozie-quick-add', sourceId: 'snoozie-quick-add', itemCount: 1, productId: String(variantId), sections: res.sections, didError: !!res.status }
      });
      return !res.status;
    } catch (e) {
      deferred.reject(e);
      return false;
    }
  }

  const getProduct = (handle) => fetch(base + '/products/' + encodeURIComponent(handle) + '.js').then((r) => r.json());

  let dlg;
  function dialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'sqa';
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    document.body.appendChild(dlg);
    return dlg;
  }

  function openPicker(p, trigger) {
    const d = dialog();
    const sel = {};
    const first = p.variants.find((v) => v.available) || p.variants[0];
    p.options.forEach((o, i) => { sel[o.name] = first['option' + (i + 1)]; });
    const variantFor = () => p.variants.find((v) => p.options.every((o, i) => v['option' + (i + 1)] === sel[o.name]));
    const label = (n) => T[n] || n;
    function render() {
      const v = variantFor();
      const img = (v && v.featured_image && v.featured_image.src) || p.featured_image;
      const imgUrl = img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_300x300_crop_center$1$2') : '';
      d.innerHTML =
        '<button type="button" class="sqa__x" aria-label="' + T.close + '">×</button>' +
        '<div class="sqa__top">' + (imgUrl ? '<img src="' + esc(imgUrl) + '" alt="" width="96" height="96">' : '') +
        '<div><p class="sqa__t">' + esc(p.title) + '</p><p class="sqa__p">' + (v ? money(v.price) : '') + '</p></div></div>' +
        p.options.map((o, i) => '<fieldset class="sqa__f"><legend>' + esc(label(o.name)) + '</legend><div class="sqa__vals">' +
          o.values.map((val) => '<button type="button" class="sqa__v' + (sel[o.name] === val ? ' is-on' : '') + '" data-opt="' + esc(o.name) + '" data-val="' + esc(val) + '" aria-pressed="' + (sel[o.name] === val) + '">' + esc(val) + '</button>').join('') +
          '</div></fieldset>').join('') +
        '<p class="sqa__msg" role="status" hidden></p>' +
        '<button type="button" class="sqa__add"' + (v && v.available ? '' : ' disabled') + '>' + (v && v.available ? T.add : T.sold) + '</button>' +
        '<a class="sqa__more" href="' + esc(p.url.split('?')[0]) + '">' + T.view + '</a>';
    }
    d.onclick = async (e) => {
      if (e.target === d) { d.close(); return; }
      const b = e.target.closest('button, a');
      if (!b) return;
      if (b.classList.contains('sqa__x')) { d.close(); return; }
      if (b.classList.contains('sqa__v')) { sel[b.dataset.opt] = b.dataset.val; render(); return; }
      if (b.classList.contains('sqa__add')) {
        const v = variantFor(); if (!v || !v.available) return;
        b.disabled = true; b.textContent = T.adding;
        const ok = await addToCart(v.id, trigger);
        if (ok) { d.close(); } else {
          const m = d.querySelector('.sqa__msg'); m.textContent = T.error; m.hidden = false; b.disabled = false; b.textContent = T.add;
        }
      }
    };
    render();
    d.showModal();
  }

  root.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qa]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';
    try {
      if (btn.dataset.vid) {
        btn.classList.add('is-busy');
        const ok = await addToCart(btn.dataset.vid, btn);
        btn.classList.remove('is-busy');
        if (ok) { btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1800); }
      } else {
        const p = await getProduct(btn.dataset.handle);
        if (p.variants.length === 1) {
          btn.classList.add('is-busy');
          const ok = await addToCart(p.variants[0].id, btn);
          btn.classList.remove('is-busy');
          if (ok) { btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1800); }
        } else {
          openPicker(p, btn);
        }
      }
    } finally { delete btn.dataset.busy; }
  });
}
